import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {URLS} from '../../environments/environment';
import {CookieService} from 'ngx-cookie-service';
import {map} from 'rxjs/operators';
import jwt_decode from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class AuthenticateService {


  constructor(private http: HttpClient, private cookieService: CookieService) {
  }

  registerUser(registerFrom: any) {
    return this.http.post(URLS.API + 'users/register', {user: registerFrom});
  }

  activateAccount(token: string) {
    return this.http.post(URLS.API + 'users/register/activate', {token});
  }

  loginUser(email: string, password: string) {
    return this.http.post(URLS.API + 'users/login', {email, password}, {withCredentials: true});
  }

  getUserData(email: string) {
    return this.http.post(URLS.API + 'users/getUserData', {email}, {withCredentials: true});
  }

  checkAuth() {
    return this.http.post(URLS.API + 'users/login/checkAuth', {}, {withCredentials: true});
  }

  getUdCookie() {
    return this.cookieService.get('ffud') || null;
  }

  isAuthenticated() {
    // try {
    console.log('isAuthenticated starts');
    const token: string = sessionStorage.getItem('token');
    if (!token) {
      return {valid: false, data: null};
    }
    // @ts-ignore
    const decodedToken: Any = jwt_decode(token);
    console.log(decodedToken);
    if (decodedToken.exp < Date.now() / 1000) {
      console.log('expired');
      return {valid: false, data: null};
    } else {
      console.log('token ok');
      return {valid: true, data: decodedToken};
    }
    // } catch (err) {
    //   return {valid: false, data: null};
    // }
  }

  forgetPassword(email: string) {
    return this.http.post(URLS.API + 'users/forget', {email});
  }

  validateResetToken(token: string) {
    return this.http.post(URLS.API + 'users/restore/validate', {token});
  }


  getOneByAuth0UserID(token: string) {
    return this.http.get(URLS.API + `users/login/getOneByAuth0UserID`, {params: {id: token}}).pipe(
      map((res: any) => res.data)
    );
  }

  updatePassword(email: string, password: string, confirm: string, code: string) {
    return this.http.post(URLS.API + 'users/password/update', {email, code, password, confirm});
  }

  logout() {
    return this.http.post(URLS.API + 'users/logout', {}, {withCredentials: true});
  }
}
